import React from 'react';
import Time from 'react-time';
import SubHeader from '../SubHeader.jsx';
import OwnersList from '../OwnersList.jsx';
import VerticalSeparator from '../VerticalSeparator.jsx';
import { ProjectLink } from '../links/index.jsx';
import { ClockIcon } from '../icons/ClockIcon.jsx';
import { LeadIcon } from '../icons/LeadIcon.jsx';
import { getOrgTermsContent } from '../../content/utils.js';

const ProjectDate = ({ value }) =>
  value ? <Time value={value} format="M/D/YY" /> : '—';

// Project header of a group on the employee Stakeholder Profiles tab: the same
// status, dates and owners as the project details header.
const EmployeeProjectGroupHeader = ({ project }) => {
  const { projectStatus, startDate, endDate, owners = [] } = project;

  return (
    <SubHeader small flexJustify>
      <div className="flex">
        <h3 className="m-0">
          <span className="text-muted m-r-12">
            {getOrgTermsContent('project')}:
          </span>
          <ProjectLink projectId={project.id}>{project.name}</ProjectLink>
        </h3>
        {projectStatus ? (
          <strong
            className={`header-item bordered ${projectStatus.archived ? 'text-muted' : ''}`}
          >
            {projectStatus.name}
          </strong>
        ) : null}
        <VerticalSeparator />
        <div className="flex header-item">
          <ClockIcon />
          <strong className="m-l-8">
            <ProjectDate value={startDate} />
            &nbsp;-&nbsp;
            <ProjectDate value={endDate} />
          </strong>
        </div>
      </div>
      <div className="flex">
        <LeadIcon />
        <strong className="text-muted m-l-8 m-r-12">
          {owners.length > 1 ? 'Owner(s):' : 'Owner:'}
        </strong>
        {owners.length ? (
          <OwnersList owners={owners} nameKey="fullName" row />
        ) : (
          '—'
        )}
      </div>
    </SubHeader>
  );
};

export default EmployeeProjectGroupHeader;
